export enum PlanFiltersTabType {
    Subscription = 'Subscription',
    Upgrade = 'Upgrade'
}

export const PlanFiltersTabTypes = Object.values(PlanFiltersTabType);